import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import UserProfileForm from "./UserProfileForm";
import CloneUserDialog from "./CloneUserDialog";
import UserCustomers from "./UserCustomers";
import UserTerritories from "./UserTerritories";
import WarrantyTab from "./WarrantyTab";

const UserRightPanel = ({
  activeTab,
  onChangeTab,
  selectedUser,
  allUsers = [],
}) => {
  const [cloneOpen, setCloneOpen] = useState(false);

  const handleClone = () => setCloneOpen(true);
  const handleClose = () => setCloneOpen(false);

  const handleApplyClone = (payload) => {
    console.log("Apply clone:", payload);
  };
  return (
    <Paper
      elevation={1}
      sx={{ height: "680px", display: "flex", flexDirection: "column" }}
    >
      <Tabs
        value={activeTab}
        onChange={(e, v) => onChangeTab && onChangeTab(v)}
        textColor="primary"
        indicatorColor="primary"
        sx={{
          borderBottom: "1px solid #e0e0e0",
          "& .MuiTab-root": { fontSize: "1.15rem" },
        }}
      >
        <Tab label="Profile" />
        <Tab label="Customers" />
        <Tab label="Territory" />
        <Tab label="Warranty" />
      </Tabs>

      <Box sx={{ p: 3, flex: 1, backgroundColor: "#fafafa" }}>
        {activeTab === 0 && (
          <UserProfileForm selectedUser={selectedUser} onClone={handleClone} />
        )}

        {activeTab === 1 && <UserCustomers initialCustomers={[]} />}

        {activeTab === 2 && <UserTerritories initialCodes={[]} />}

        {activeTab === 3 && <WarrantyTab selectedUser={selectedUser} />}
      </Box>

      <CloneUserDialog
        open={cloneOpen}
        onClose={handleClose}
        onApply={handleApplyClone}
        selectedUser={selectedUser}
        allUsers={allUsers}
      />
    </Paper>
  );
};

export default UserRightPanel;
